<template>
    <div class="pageTableUsers">
        <ListTableHeader :route="elementRoute" :text-header="$t('Kraje')"
                         :text-button="`+ ` + $t('Dodaj Kraj')"></ListTableHeader>

        <div class="row">
            <div class="col-12">
                <perfect-scrollbar class="scroll-table">
                    <b-table
                            striped
                            :items="elementsFiltered"
                            :fields="fields"
                            :per-page="perPage"
                            :current-page="currentPage"
                            class="custom table-users"
                            :tbody-tr-class="rowClass">
                        <template slot="top-row" class="sub-header">
                            <td :key="key" v-for="(field, key) in fields">
                                <template v-if="[2,0,1,3].indexOf(key) !== -1">
                                    <div class="d-flex ">
                                        <div class="input-group sm custom search ">
                                            <input type="text"
                                                   :placeholder="$t('Wyszukaj')"
                                                   v-model="filters[field.key]"
                                                   class="form-control sm custom">
                                        </div>
                                    </div>
                                </template>
                            </td>
                        </template>

                        <template slot="actions" slot-scope="scope">
                            <div class="wrap-ico-btn d-flex justify-content-center align-items-center">
                                <EditButton :route="elementRoute"
                                            :item-id="scope.item.id">
                                </EditButton>
                                <DeleteButton :item-id="scope.item.id" :return-param="`deleteCountry`"
                                              :item-title="scope.item.name">
                                </DeleteButton>
                            </div>
                        </template>
                    </b-table>
                </perfect-scrollbar>
            </div>
        </div>
        <b-row>
            <b-pagination v-show="totalRows > perPage"
                          v-model="currentPage"
                          :total-rows="totalRows"
                          :per-page="perPage"
                          class=" custom"></b-pagination>

        </b-row>
        <confirmDeleteModal></confirmDeleteModal>
    </div>

</template>

<script>
import confirmDeleteModal from '@/components/Modals/ConfirmDeleteModal'
import { mapActions } from 'vuex'
import standartFilterMixin from '@/mixins/standartFilterMixin'

import EditButton from '@/components/Buttons/EditButton'
import DeleteButton from '@/components/Buttons/DeleteButton'
import ListTableHeader from '@/components/Headers/ListTableHeader'

export default {
  name: 'adminCountries',
  components: {
    confirmDeleteModal,
    EditButton,
    DeleteButton,
    ListTableHeader
  },
  mixins: [standartFilterMixin],
  data () {
    return {
      elementRoute: 'admin.administration.country',
      fields: [
        { key: 'id', label: this.$t('#'), sortable: true },
        { key: 'name', label: this.$t('Nazwa kraju'), sortable: true },
        { key: 'code', label: this.$t('Prefiks kraju'), sortable: true },
        { key: 'connectionPrefix', label: this.$t('Kod kraju'), sortable: true },
        { key: 'actions', label: this.$t('Operacje') }
      ]
    }
  },
  methods: {
    ...mapActions(['getCountries']),
    rowClass (item, type) {
      if (type === 'row-top') {
        return 'sub-header'
      }
      return ''
    }
  },
  computed: {
    elements () {
      return this.$store.getters.countries
    }
  },
  created () {
    this.getCountries()
  }
}
</script>

<style scoped>

</style>
